import axios from "axios";
import label from "@/lang/StaticLabels";
// import alert from "@/lang/AlertMessages.js";
// import label from "@/lang/StaticLabels.js";
const splyUrl = "Sply/api/v1/";

export default {
  // SCMS Setting Actions ------------------------------------------------------------------
    getScmsSetting({ dispatch, commit }) {
      commit(
        "setLoading",
        { status: 1, message: label.caption.loading },
        { root: true },
      );
      axios
        .get(splyUrl + "basic/scms/Setting")
        .then((res) => {
          commit("setScmsSetting", res.data.data);
        })
        .catch((error) => {
          dispatch("errorGETHandler", error, { root: true });
        })
        .finally(() => {
          setTimeout(() => {
            commit("setLoading", { status: 0, message: "" }, { root: true });
          }, 500);
        });
    },
  
    editScmsSetting({ dispatch, commit }, data) {
      commit("setLoadingBtn", true, { root: true });
      axios
        .put(splyUrl + "basic/scms/Setting/" + data.id, data.value)
        .then((res) => {
          dispatch(
            "successPOSTHandler",
            {
              server: res,
              message: alert.success.edit,
              redirect: false,
            },
            { root: true },
          );
        })
        .catch((error) => {
          dispatch("errorPOSTHandler", error, { root: true });
        })
        .finally(() => {
          setTimeout(() => {
            commit("setLoadingBtn", false, { root: true });
          }, 1000);
        });
    },

  // buy factor ------------------------------------------------------
  getBuyFactor({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/BuyFactor?" + data)
      .then((res) => {
        commit("setBuyFactor", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getBuyFactorById({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "operation/BuyFactor/" + data)
      .then((res) => {
        commit("setBuyFactorById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addBuyFactor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/BuyFactor", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PSCMSBuyFactorList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addBuyFactorReturn({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/BuyFactor/Return", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteBuyFactor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "operation/BuyFactor", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editBuyFactor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/BuyFactor/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PSCMSBuyFactorList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getBuyFactorMaxCode({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "operation/BuyFactor/MaxCode")
      .then((res) => {
        commit("setBuyFactorMaxCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getBuyFactorSearch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "operation/BuyFactor/get/" + data)
      .then((res) => {
        commit("setBuyFactorById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getBuyFactorNavigation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "operation/BuyFactor/Navigation?" + data)
      .then((res) => {
        commit("setBuyFactorById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  buyFactorCancelOperation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        splyUrl + "operation/BuyFactor/CancelOperation?status=" + data.status,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  buyFactorConfirmOperation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        splyUrl + "operation/BuyFactor/ConfirmOperation?status=" + data.status,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  sortBuyFactorCode({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/BuyFactor/SortCode", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  buyFactorSortCode({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/BuyFactor/sortCode")
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getBuyFactorAddMinus({ dispatch, commit }) {
    axios
      .get(splyUrl + "operation/BuyFactorAddMinus")
      .then((res) => {
        commit("setBuyFactorAddMinus", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReadBuyRequestByCode({ dispatch, commit }, data) {
      commit("setLoadingBtn", true, { root: true });
      axios
        .get(splyUrl + "operation/BuyFactor/ReadBuyRequest?code=" + data)
        .then((res) => {
          commit("setReadBuyRequestByCode", res.data.data);
          dispatch(
            "successPOSTHandlerSilent2",
            {
              server: res,
              redirect: false,
            },
            { root: true },
          );
        })
        .catch((error) => {
          dispatch("errorPOSTHandler2", error, { root: true });
        })
        .finally(() => {
          setTimeout(() => {
            commit("setLoadingBtn", false, { root: true });
          }, 1000);
        });
    },

  getReadBuyRequestByCommodity({ dispatch, commit }, data) {
      commit("setLoadingBtn", true, { root: true });
      axios
        .get(splyUrl + "operation/BuyFactor/ReadBuyRequest?commodityId=" + data)
        .then((res) => {
          commit("setReadBuyRequestByCommodity", res.data.data);
          dispatch(
            "successPOSTHandlerSilent2",
            {
              server: res,
              redirect: false,
            },
            { root: true },
          );
        })
        .catch((error) => {
          dispatch("errorPOSTHandler2", error, { root: true });
        })
        .finally(() => {
          setTimeout(() => {
            commit("setLoadingBtn", false, { root: true });
          }, 1000);
        });
    },

  // buy factor attachment --------------------------------------------------
  getBuyFactorAttachment({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "operation/BuyFactorAttachment?" + data)
      .then((res) => {
        commit("setBuyFactorAttachment", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBuyFactorAttachmentById({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "operation/BuyFactorAttachment/" + data)
      .then((res) => {
        commit("setBuyFactorAttachmentById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addBuyFactorAttachment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/BuyFactorAttachment", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteBuyFactorAttachment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "operation/BuyFactorAttachment", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editBuyFactorAttachment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/BuyFactorAttachment/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //Buy Notes ---------------------------------------------
  getBuyNotes({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "operation/BuyFactorDocument?orderId=" + data)
      .then((res) => {
        commit("setBuyNotes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addBuyNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/BuyFactorDocument", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler2", error, { root: true });
      });
  },

  editBuyNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/BuyFactorDocument/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler2", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteBuyNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "operation/BuyFactorDocument", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler2", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // return buy factor ------------------------------------------------------
  getReturnBuyFactor({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/ReturnBuyFactor?" + data)
      .then((res) => {
        commit("setReturnBuyFactor", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getReturnBuyFactorById({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "operation/ReturnBuyFactor/" + data)
      .then((res) => {
        commit("setReturnBuyFactorById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addReturnBuyFactor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/ReturnBuyFactor", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PSCMSReturnBuyFactorList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteReturnBuyFactor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "operation/ReturnBuyFactor", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editReturnBuyFactor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/ReturnBuyFactor/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PSCMSReturnBuyFactorList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReturnBuyFactorMaxCode({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "operation/ReturnBuyFactor/MaxCode")
      .then((res) => {
        commit("setReturnBuyFactorMaxCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReturnBuyFactorSearch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "operation/ReturnBuyFactor/get/" + data)
      .then((res) => {
        commit("setReturnBuyFactorById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReturnBuyFactorNavigation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "operation/ReturnBuyFactor/Navigation?" + data)
      .then((res) => {
        commit("setReturnBuyFactorById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  returnBuyFactorCancelOperation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        splyUrl +
          "operation/ReturnBuyFactor/CancelOperation?status=" +
          data.status,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  returnBuyFactorConfirmOperation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        splyUrl +
          "operation/ReturnBuyFactor/ConfirmOperation?status=" +
          data.status,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  returnBuyFactorSortCode({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/ReturnBuyFactor/sortCode")
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // buy factor attachment --------------------------------------------------
  getReturnBuyFactorAttachment({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "operation/ReturnBuyFactorAttachment?" + data)
      .then((res) => {
        commit("setReturnBuyFactorAttachment", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReturnBuyFactorAttachmentById({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "operation/BuyFactorAttachment/" + data)
      .then((res) => {
        commit("setReturnBuyFactorAttachmentById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addReturnBuyFactorAttachment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/ReturnBuyFactorAttachment", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteReturnBuyFactorAttachment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "operation/ReturnBuyFactorAttachment", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editReturnBuyFactorAttachment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        splyUrl + "operation/ReturnBuyFactorAttachment/" + data.id,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //Buy Notes ---------------------------------------------
  getReturnBuyNotes({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/ReturnBuyFactorDocument?orderId=" + data)
      .then((res) => {
        commit("setReturnBuyNotes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addReturnBuyNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(splyUrl + "operation/ReturnBuyFactorDocument", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteReturnBuyNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(splyUrl + "operation/ReturnBuyFactorDocument", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editReturnBuyNote({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/ReturnBuyFactorDocument/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //Report..........................................................................................
  getLatestBuyPriceOfCommodityReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "Report/LatestBuyPriceReportOfCommodity?" + data)
      .then((res) => {
        commit("setLatestBuyPriceOfCommodityReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getFactorComprehensiveReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "Report/ComprehensiveBuyFactorReport?" + data)
      .then((res) => {
        commit("setFactorComprehensiveReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getCommodityComprehensiveReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "Report/ComprehensiveBuyFactorReportByCommodity?" + data)
      .then((res) => {
        commit("setCommodityComprehensiveReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getMonthlyPurchaseSomeReport({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "Report/MonthlyPurchaseQuantityReportOfCommodities")
      .then((res) => {
        commit("setMonthlyPurchaseSomeReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getMonthlyPurchaseMonetaryReport({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "Report/MonthlyMonetaryPurchaseReportOfCommodities")
      .then((res) => {
        commit("setMonthlyPurchaseMonetaryReport", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getBuyReportBySuppliers({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "Report/BuyReportBySuppliers?" + data)
      .then((res) => {
        commit("setBuyReportBySuppliers", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getBuyReportBySuppliersFactorList({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "Report/BuyReportBySuppliersFactorList?" + data)
      .then((res) => {
        commit("setBuyReportBySuppliersFactorList", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getBuyReportBySuppliersCommodityList({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "Report/BuyReportBySuppliersCommodityList?" + data)
      .then((res) => {
        commit("setBuyReportBySuppliersCommodityList", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getBuyReportBySuppliersAddMinusList({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(splyUrl + "Report/BuyReportBySuppliersAddMinusList?" + data)
      .then((res) => {
        commit("setBuyReportBySuppliersAddMinusList", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //BuyFactor Cartable Management ..................................................................................
  getBuyFactorManagementCartable({ dispatch, commit }, data) {
    axios
      .get(
        splyUrl + "operation/BuyFactor/BuyFactorManagementCartableList?" + data,
      )
      .then((res) => {
        commit("setBuyFactorManagementCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  buyFactorNextStepCartable({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/BuyFactor/NextStepManagementCartable", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  buyFactorManagementCartable({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/BuyFactor/ManagementCartable", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  buyFactorCancelCartable({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/BuyFactor/CancelManagementCartable", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  buyFactorSendSpecialStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        splyUrl + "operation/BuyFactor/SpecialStatusManagementCartable",
        data,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  //BuyReturn Cartable Management ..................................................................................
  getBuyReturnManagementCartable({ dispatch, commit }, data) {
    axios
      .get(
        splyUrl +
          "operation/ReturnBuyFactor/ReturnBuyFactorManagementCartableList?" +
          data,
      )
      .then((res) => {
        commit("setBuyReturnManagementCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  buyReturnManagementCartable({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/ReturnBuyFactor/ManagementCartable", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //BuyReturn Cartable Management ..................................................................................
  getReqBuyManagementCartable({ dispatch, commit }, data) {
    axios
      .get(splyUrl + "operation/ReqBuy/ReqBuyManagementCartableList?" + data)
      .then((res) => {
        commit("setReqBuyManagementCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  reqBuyManagementCartable({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(splyUrl + "operation/ReqBuy/ManagementCartable", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //  BuyFactor Cartable ................................................................................
  getBuyFactorCartable({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/BuyFactor/BuyFactorCartable")
      .then((res) => {
        commit("setBuyFactorCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  buyFactorChangeStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios

      .post(splyUrl + "operation/BuyFactor/ChangeStatus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //  ReqBuy Cartable ................................................................................
  getReqBuyCartable({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/ReqBuy/ReqBuyCartable")
      .then((res) => {
        commit("setReqBuyCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  reqBuyChangeStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios

      .post(splyUrl + "operation/ReqBuy/ChangeStatus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // ReturnBuyFactor Cartable ................................................................................
  getReturnBuyFactorCartable({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/ReturnBuyFactor/ReturnBuyFactorCartable")
      .then((res) => {
        commit("setReturnBuyFactorCartable", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  returnBuyFactorChangeStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios

      .post(splyUrl + "operation/ReturnBuyFactor/ChangeStatus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  returnBuyFactorReturnStatus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios

      .post(splyUrl + "operation/ReturnBuyFactor/ReturnStatus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //Factor Dynamic Actions ..................................................................................
  getFactorCalculate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(data.action, data.form)
      .then((res) => {
        commit("setFactorCalculate", res.data.data);
        dispatch(
          "successPOSTHandlerSilent",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getFactorAddMinus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(data.action, data.form)
      .then((res) => {
        commit("setFactorAddMinus", res.data.data);
        dispatch(
          "successPOSTHandlerSilent",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getFactorCalculateAddMinus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(data.action, data.form)
      .then((res) => {
        commit("setFactorCalculateAddMinus", res.data.data);
        dispatch(
          "successPOSTHandlerSilent",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // CartableLog Actions ------------------------------------------------------------------
  getCartableLog({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(splyUrl + "operation/scms/CartableLog?" + data)
      .then((res) => {
        commit("setCartableLog", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
};
